(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-components/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-components/assets/javascripts/constants.js');
"use strict";

const dispatchTypes = {
  CENTER_INDEX: 'centerIndex',
  SELECT_INDEX: 'selectIndex',
  GO_TO_NEXT: 'goToNext',
  GO_TO_PREVIOUS: 'goToPrevious',
  GO_TO_SELECTED: 'goToSelected'
};
const elementSizes = {
  DRAW_PANEL_WIDE_WIDTH: 312,
  DRAW_PANEL_WIDTH: 284,
  MARGIN_BASE: 12
};
const keys = {
  tabKeys: {
    TAB: 'Tab'
  },
  submitKeys: {
    ENTER: 'Enter',
    SPACE: ' '
  },
  navigationKeys: {
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown'
  }
};
const MINIMAL_REQUIRED_SWIPE_DISTANCE = 20;
const TEAM_NAME_MAX_ALLOWED_LENGTH = 22;
setGlobal('svs.components.tipsen.drawSelectorComponents.constants', {
  dispatchTypes,
  elementSizes,
  keys,
  MINIMAL_REQUIRED_SWIPE_DISTANCE,
  TEAM_NAME_MAX_ALLOWED_LENGTH
});

 })(window);